<template>
  <div class="sectors" id="SectorListContainer">
    <div class="sector-filters">
      <div class="row">
        <div class="small-5 columns padding-R">
          <div class="field-input">
            <label>COVERAGE DATE</label>
            <!--date-picker v-model="filterStartDate" format="MM/dd/yyyy" @selected="filterSectors(false)" :disabled="{ from: filterEndDate }"
                         :highlighted="{ from: filterStartDate, to: filterEndDate }"
                         input-class="sectorfilter-dateinput" calendar-class="sectorfilter-calendar"></date-picker-->
            <date-picker v-model="filterStartDate" format="MM/dd/yyyy" @selected="filterSectors(false)"
              input-class="sectorfilter-dateinput" calendar-class="sectorfilter-calendar"></date-picker>
          </div>
        </div>
        <!--div class="small-3 columns padding-L padding-R">
          <div class="field-input">
            <label>END DATE</label>
            <date-picker v-model="filterEndDate" format="MM/dd/yyyy" @selected="filterSectors(false)" :disabled="{ to: filterStartDate }"
                         :highlighted="{ from: filterStartDate, to: filterEndDate }"
                         input-class="sectorfilter-dateinput" calendar-class="sectorfilter-calendar"></date-picker>
          </div>
        </div-->
        <div class="small-2 columns padding-L padding-R">
          <a v-bind:class="{ 'button cta xsmall success report-btn': true, disabled: filterBtnDisabled }" @click="filterSectors(true)">REFRESH</a>
        </div>
        <div class="small-5 columns padding-L">
          <a v-bind:class="{ 'button cta xsmall block report-btn': true, disabled: filterBtnDisabled || generatingReport }"
             href="javascript:;" @click="generateReport">
             <i class="fa fa-spinner fa-spin" v-show="generatingReport"></i>
             <span v-show="!generatingReport">GENERATE REPORT</span>
           </a>
        </div>
      </div>
    </div>

    <div class="sector-items">
      <div class="sector" v-for="(sector, index) in sectorItems" :id="sector.identifier" :key="index">
        <div class="header" @click="togglePanel(index)">
          <div class="sector-label">
            <span class="sector-color" :style="{ backgroundColor: sector.overlayColor}"></span>
            <span class="mainlabel">{{ sector.name }}</span>
          </div>
          <div class="sublabel">{{ sector.identifier }}</div>
          <div class="alert-icon">
            <i class="fa fa-check-circle fa-lg" v-show="sector.issueState === 'ok'"></i>
            <i class="fa fa-exclamation-circle fa-lg" v-show="sector.issueState === 'has-issues'"></i>
            <i class="fa fa-spinner fa-spin fa-lg" v-show="sector.issueState === 'loading'"></i>
          </div>
          <i class="fa fa-chevron-down expand-icon" v-show="!sector.showPanel"></i>
          <i class="fa fa-chevron-up expand-icon" v-show="sector.showPanel"></i>
        </div>
        <div :class="['sector-body', {show: sector.showPanel}]">
          <coverage-calendar :sector="sector" :ref="'coverageCalendar' + index"></coverage-calendar>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'sector-loading': true, show: sectorLoading }">
      <div class="loading-label">
        <i class="fa fa-spinner fa-spin"></i>
        <div>LOADING</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vuejs-datepicker'
import VueScrollTo from 'vue-scrollto'
import CoverageCalendar from './Calendar'
import ReportGenerator from './report-generator'
export default {
  name: 'sector-list',
  components: { DatePicker, CoverageCalendar },
  data () {
    return {
      sectorName: '',
      generatingReport: false,
      openSector: []
    }
  },
  computed: {
    sectorItems () { return this.$store.state.coverage.sectors.items },
    sectorLoading () { return this.$store.state.coverage.sectors.loading },
    filterSearch: {
      get () { return this.$store.state.coverage.filters.search },
      set (value) { this.$store.commit('coverage/setCoverageFilterSearch', value) }
    },
    filterStartDate: {
      get () { return this.$store.state.coverage.filters.startDate },
      set (value) {
        this.$store.commit('coverage/setCoverageFilterStartDate', value)
        let endDate = moment(value)
        let format = 'MM/DD/YYYY hh:mm:ssA'
        let end = moment(endDate.format('MM/DD/YYYY') + ' 11:59:59PM', format)
        this.$store.commit('coverage/setCoverageFilterEndDate', end.toDate())
      }
    },
    filterEndDate: {
      get () { return this.$store.state.coverage.filters.endDate },
      set (value) { this.$store.commit('coverage/setCoverageFilterEndDate', value) }
    },
    filterBtnDisabled () {
      let sectors = this.sectorItems
      for (let i = 0; i < sectors.length; i++) {
        if (sectors[i].issueState === 'loading') {
          return true
        }
      }
      return false
    },
    refreshData () { return this.$store.state.coverage.sectors.refresh },
    scrollSector () { return this.$store.state.coverage.sectors.scrollElement }
  },
  methods: {
    togglePanel (index) {
      this.$store.commit('coverage/setCoverageSectorsPanelShow', index)

      if (this.$refs['coverageCalendar' + index][0].triggerShowCalendarInfo()) {
        this.$refs['coverageCalendar' + index][0].triggerShowCalendarInfo()
      }

      let sectorID = this.sectorItems[index].ID
      if (this.openSector.indexOf(sectorID) === -1) {
        this.openSector.push(sectorID)
        this.$store.commit('coverage/setCoverageMapKml', sectorID)
        this.$store.commit('coverage/addKml', sectorID)
      } else {
        let index = this.openSector.indexOf(sectorID)
        this.openSector.splice(index, 1)
        this.$store.commit('coverage/removeKml', sectorID)
      }
    },
    setSectorName () {
      let self = this
      if (self.filterSelectedSector === -1) {
        self.sectorName = ''
        return
      }

      for (let i = 0; i < self.filterSectors.length; i++) {
        let sector = self.filterSectors[i]
        if (sector.ID !== self.filterSelectedSector) {
          continue
        }
        self.sectorName = sector.name
        break
      }
    },
    filterSectors (refresh) {
      let self = this
      self.$store.commit('coverage/setCoverageSectorsLoading', true)
      self.$sdk.get('/sectors', {
        token: self.$store.state.session.sessionToken,
        polygon: 1,
        pageSize: 50
      }, r => {
        self.$store.commit('coverage/setCoverageSectorsLoading', false)
        self.$store.commit('coverage/setCoverageReportSectors', [])
        if (r.error) {
          return
        }
        // self.setSectorName()
        let sectors = []
        for (let i = 0; i < r.list.length; i++) {
          let sector = r.list[i]
          sector['showPanel'] = false
          sector['issueState'] = 'loading'
          sector['unassigned'] = []
          sector['shiftGaps'] = []
          sector['polygonOptions'] = {
            zIndex: 0,
            strokeWeight: 2,
            fillOpacity: 0.25
          }
          sector['bodyHeight'] = 0;
          sectors.push(sector)
        }
        self.$store.commit('coverage/setCoverageSectors', sectors)
        if (refresh) {
          setTimeout(() => {
            self.$store.commit('coverage/setCoverageFilterStartDate', moment(self.filterStartDate).toDate())
            self.$store.commit('coverage/setCoverageSectorsRefresh', false)
          }, 500)
        }
      })
    },
    generateReport () {
      let self = this
      self.generatingReport = true
      ReportGenerator.generateReport(self, () => {
        self.generatingReport = false
      })
    }
  },
  watch: {
    refreshData (value) {
      if (!value) {
        return
      }
      this.filterSectors(true)
    },
    scrollSector (value) {
      if (value === null) {
        return
      }
      setTimeout(() => {
        VueScrollTo.scrollTo('#' + value, 250, {
          container: '#SectorListContainer',
          easing: 'ease-in',
          offset: -100,
          force: true,
          cancelable: true,
          onStart: function(element) {
            // scrolling started
          },
          onDone: function(element) {
            // scrolling is done
          },
          onCancel: function() {
            // scrolling has been interrupted
          },
          x: false,
          y: true
        })
      }, 500)
    }
  },
  mounted () {
    let self = this
    let now = moment()
    let format = 'MM/DD/YYYY hh:mm:ssA'
    let start = moment(now.format('MM/DD/YYYY') + ' 00:00:00AM', format)
    let end = moment(now.format('MM/DD/YYYY') + ' 11:59:59PM', format) // moment().add(13, 'days')
    self.$store.commit('coverage/setCoverageFilterStartDate', start.toDate())
    self.$store.commit('coverage/setCoverageFilterEndDate', end.toDate())
    self.$store.commit('coverage/setCoverageMapShowPolygons', true)
    self.filterSectors()
  }
}
</script>

<style lang="scss" scoped>
.sectors {
  height: 100%;
  position: relative;
  overflow: hidden;
}

.sector-filters {
  position: fixed;
  width: 40%;
  top: 0;
  background-color: #fff;
  z-index: 1;
  padding: 5px 13px 13px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);

  & .report-btn { margin-top: 25px; }
}

.sector-items {
  margin-top: 93px;
  height: calc(100% - 80px);
  overflow-y: auto;
  overflow-x: auto;
}

.sector {
  background-color: #fff;
  font-size: 14px;
  margin: 12px 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  border-radius: 3px;

  & .header {
    position: relative;
    cursor: pointer;
    background-color: #fff;
    transition: all 250ms;
    padding: 10px 13px 12px;
    cursor: pointer;

    &:hover { background-color: #f5f5f5; }

    & .expand-icon {
      position: absolute;
      top: 23px;
      right: 13px;
      color: #777;
    }

    & .alert-icon {
      position: absolute;
      top: 20px;
      right: 40px;

      & .fa-check-circle { color: #26D97A; }
      & .fa-exclamation-circle { color: #F25E0D; }
    }
  }

  & .sector-label {

    & > span {
      display: inline-block;
      vertical-align: middle;
    }

    & .sector-color {
      width: 15px;
      height: 15px;
      margin-right: 3px;
    }
    & .mainlabel {
      font-size: 18px;
      line-height: 18px;
      font-weight: 700;
      color: #333;
    }
  }

  & .sublabel {
    font-size: 12px;
    line-height: 12px;
    margin-top: 5px;
    color: #555;
  }
}

.sector-body {
  height: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top: 1px solid rgba(0,0,0,0.15);
  transition: all 250ms;
  // min-height: 300px;

  &.show { height: 526px; }
}

.sector-loading {
  position: fixed;
  top: -100%;
  right: 0;
  opacity: 0;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
  width: 40%;
  height: 100%;
  transition: all 250ms;

  &.show { top: 0; opacity: 1; }

  & .loading-label {
    text-align: center;
    color: #fff;
    margin-top: 300px;

    & div {
      font-size: 18px;
    }
  }
}

.field-input {
  & label {
    color: #0D79F2;
    font-weight: 700;
    font-size: 10px;
  }

  & input {
    margin-top: 0;
    font-size: 14px;
    padding: 7px 7px;
  }

  select {
    font-size: 14px;
    height: 37px;
    outline: 0;
    padding: 7px 7px;
    display: block;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }
}
.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
</style>



// WEBPACK FOOTER //
// src/components/Coverage/SectorList.vue